import { render, staticRenderFns } from "./BasicTile.vue?vue&type=template&id=b2eae562&functional=true&"
import script from "./BasicTile.vue?vue&type=script&lang=js&"
export * from "./BasicTile.vue?vue&type=script&lang=js&"
import style0 from "./BasicTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports